import React from "react";
import { FaInstagram } from "react-icons/fa";

function InstagramButton() {
    return(
        <div className="instagram-button"><a href="https://www.instagram.com/sogdiana.sk/" target="_blank" rel="noopener noreferrer"><FaInstagram></FaInstagram></a></div>
    )
}
export default InstagramButton